
import AnchorLink from "./AnchorLink";

const HalfAndHalf = (props) => {
    const {image,flipped,heading,description,buttonObject} = props;

    return (

        <div className={`${props.className} row half-half`}>
            <div className={`col-12 col-lg-6 ${flipped && 'order-lg-2 order-1'}`}>
                {image && 
                <div className="image">
                    <img 
                        alt='Lorem Ipsum is simply dummy text of the printing and typesetting industry.'
                        src={image}
                        width={0}
                        height={0}
                        sizes="100vw"
                        style={{ width: '100%', height: 'auto' }}
                    />
                </div>
                }
            </div>
            <div className={`col-12 col-lg-6 ${flipped && 'order-lg-1 order-1'}`}>
                <div className={`${flipped ? 'pe-0 pe-lg-5 me-0 me-xxl-4':'ps-0 ps-lg-5 ms-0 ms-xxl-4'} mt-5 mt-lg-0`}>
                    <h2>{heading}</h2>
                    <p style={{lineHeight:"2"}} dangerouslySetInnerHTML={{__html:description}}></p>

                    

                    {buttonObject &&
                        <div className="my-5 text-center">
                            <AnchorLink
                                {...buttonObject}
                            />
                        </div>
                    } 
                </div>
            </div>
        </div>
    );
};

export default HalfAndHalf;